module.exports = __webpack_public_path__ + "static/media/cards-stack.0ddadb43.png";